import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actResetPassword, actUserResetPasswordBegin } from 'actions/loginStateActions';
import ResetPasswordComponent from './view';

const mapStateToProps = (state) => ({ ...state.loginState });

const mapDispatchToProps = (dispatch) => ({
  onInit: bindActionCreators(actUserResetPasswordBegin, dispatch),
  onResetPassword: bindActionCreators(actResetPassword, dispatch),
});

const ResetPassword = connect(mapStateToProps, mapDispatchToProps)(ResetPasswordComponent);

export default ResetPassword;
